import {useAlert} from "@cjdev-internal/visual-stack-x/Alert";

export const AlertBar = (props) => {
    const [alertMount, openAlert, closeAlert] = useAlert();
    openAlert(props.myAlertProps)
    return (
        <>
        </>
    );
};